export const tweaks = {
  perWordBonus: 5,
  noMissesBonus: 10,
  fastFingersBonus: 10,
  perDoubleGreensBonus: 5,
}
